<template>
    <div v-if="!occupied">
      <b-form @submit.prevent>
        <b-row>
          <!-- Project -->
          <b-col>
            <div class="text-container keyword-label-area">
              <label for="project-list">Project</label>
              <div class="search-toggle-area">
                  <span>{{projectToggleLabel}}</span>
                  <b-input-group-append is-text>
                    <b-form-checkbox switch
                                    class="mr-2"
                                    v-model="isProjectToggled"
                                    :value="true"
                                    :unchecked-value="false"
                                    >
                    </b-form-checkbox>
                  </b-input-group-append>
                </div>
            </div>
            <b-form-select id="project-list"
                           size="sm"
                           class="mr-4"
                           @change="reload"
                           v-model="filter.projectId"
                           :options="options('project')"
                           ></b-form-select>
          </b-col>
          <!-- /Project -->
          <!-- Status -->
          <b-col>
            <label for="status-list">Status</label>
            <b-form-select id="status-list"
                           size="sm"
                           class="mr-4"
                           @change="reload"
                           v-model="filter.status"
                           :options="options('status')"
                           ></b-form-select>
          </b-col>
          <!-- /Status -->
          <!-- Keyword -->
          <b-col>
            <div class="text-container keyword-label-area">
              <label for="Keyword">Keyword</label>
            </div>
            <b-input-group size="sm">
              <b-form-input placeholder="Keyword"
                            @keyup.enter="reload"
                            v-model="filter.keyword"
                            />
            </b-input-group>
          </b-col>
          <!-- /Keyword -->
        </b-row>
      </b-form>
    </div>
  </template>
  
  <script>
  export default {
    name: "FileFilter",
    //isRefreshed: Chatter List에서 새로고침 되었는지
    props:['isRefreshed', 'isStatusBarClicked'],
    computed: {
      filter() {
        return this.$store.getters['chatterFiles/filter'];
      },
      firstHalfItemInfo() {
        const halfIndex = Math.ceil(this.tableInfo.length / 2);
        return this.tableInfo.slice(0, halfIndex);
      },
      secondHalfItemInfo() {
        const halfIndex = Math.ceil(this.tableInfo.length / 2);
        return this.tableInfo.slice(halfIndex);
      },
      isQueryId(){
        return !this.queryId;
      },
      projectToggleLabel(){
        return this.isProjectToggled ? "With Closed Projects" : "Without Closed Projects";
      },
      statusBar(){
        return this.$store.getters['chatter/statusBar'];
      },
      projectOptions(){
        return this.$store.getters['chatter/options']['projectOptions'];
      },
      occupied(){
        return this.$store.getters['chatter/occupied'];
      },
    },
    watch:{
      //refresh 버튼 클릭여부
      isRefreshed(){
      //refresh 클릭시(refresh 동작)
        if(this.isRefreshed==true){
            //Without Closed Projects로 초기화
            this.isProjectToggled=false;
        }
      },
      //with closed projects, without closed projects toggle
      isProjectToggled(){
        //without closed
        if(this.isProjectToggled==false){
          //현재 선택한 project가 closed이면
          if(this.projectOptions.filter(obj=>obj.projectId==this.filter.projectId)[0].status=="CLOSED"){
            //filter의 project 초기화
            this.$store.commit('chatter/setFilterProjectId', "");
            this.reload();
          }
          //현재 선택한 project가 closed가 아니면
          else{
            console.log("isProjectToggled",this.isProjectToggled);
          }
        }
      }
      
    },
    data() {
      return {
        currQueryOrderBy:'',
        isProjectToggled:false,
      }
    },
    created() {
      this.$store.dispatch('chatter/retrieveAssigneeOptions');

      if(this.filter.projectId!=""){
        this.isProjectToggled=true;
      }
      
    },
    methods: {
      options(type) {
        let optionsObj =  this.$store.getters['chatter/options'][type+'Options'];
        let allOption = null;
        switch (type) {
          case 'project':
            allOption = { value: "", text: "All Projects" };
            //toggle 여부에 따라 보이는 project 다르게
            if(this.isProjectToggled==false){
              return [allOption, ...optionsObj.filter(obj=>obj.status=="OPEN")]
            }
            break;
          case 'status':
            allOption = { value: "", text: "All Status" };
            break;
          case 'assignee':
            allOption = { value: "", text: "All Assignees" };
            break;
        }
        return [allOption, ...optionsObj];
      },
      reload() {
        //filter 클릭시 status bar 비활성화
        this.$store.commit('chatter/setOccupied', false);
        //statusbar 정보 초기화
        // this.$store.commit('chatter/resetStatusBar');
        this.$store.commit('chatter/setFilterOccupied', true);
        this.$emit('reload');
      },
    },
    
  }
  </script>
  <style>
  .text-container {
      white-space: nowrap;
      /* 텍스트가 줄바꿈되지 않도록 설정 */
      overflow: hidden;
      /* 너비를 초과하는 텍스트를 감추기 */
      text-overflow: ellipsis;
      /* 초과된 텍스트를 "..."으로 표기 */
  }
  
  /* 신규 추가 스타일 */
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
  
  /* button */
  .chatter-list .btn {
      border-radius: 10px;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      border: none;
  }
  
  .chatter-list .btn:focus {
      box-shadow: none;
  }
  
  .chatter-list .btn-secondary {
      width: 148px;
      height: 60px;
      border-radius: 10px;
      background: #747480;
      color: #fff;
  }
  
  .chatter-list .btn-secondary.small {
      height: 40px;
      justify-content:cneter !important;
  }
  
  .chatter-list .btn-secondary:hover {
      background-color: #565662;
  }
  
  .chatter-list .btn-secondary.disabled,
  .chatter-list .btn-secondary:disabled {
      color: #9C9CA8;
      background-color: #C4C4CD;
      border-color: transparent;
  }
  
  .chatter-list .btn-primary {
      width: 280px;
      height: 60px;
      background-color: #2E2E38;
      color: #FFE600;
      border-color: transparent;
  }
  
  .chatter-list .btn-primary:hover {
      color: #FFE600;
      background-color: #0D0D17;
      border-color: transparent;
  }
  
  .chatter-list .btn-primary.disabled,
  .chatter-list .btn-primary:disabled {
      color: #9C9CA8;
      background-color: #C4C4CD;
      border-color: transparent;
  }
  
  .chatter-list .btn-primary.small {
      width: 148px;
      height: 40px;
  }
  
  .chatter-list .card-body .btn-wrap {
      display: flex;
      gap: 0 2rem;
      justify-content: end;
      margin-top: 3rem;
      margin-bottom: 1.33rem;
  }
  
  .chatter-list .btn-wrap .btn-group-area {
      position: relative;
      display: flex;
      gap: 0 0.666rem;
  }
  
  .chatter-list .btn-wrap .btn-group-area::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: -1rem;
      transform: translateY(-50%);
      width: 1px;
      height: calc(100% - 1.066rem);
      background-color: #DDDDE3;
  }
  
  /* select */
  .chatter-list .custom-select {
      padding: 0.533rem 2.1rem 0.533rem 1.066rem;
      height: 2.666rem;
      border-radius: 10px;
      border: 1px solid #E7E7EE;
      background-color: #F6F6FA;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      background-position: calc(100% - 12px) 9px;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      font-family: 'NanumGothic';
      color: #2E2E38;
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
  }
  
  .chatter-list .chatter-list .custom-select:focus {
      border-color: #E7E7EE;
      box-shadow: unset;
  }
  
  /* new-query select */
  .chatter-list .custom-select.new-query {
      background-color: #FFF;
      overflow-y: hidden;
      padding: 1.066rem !important;
      min-height: 180px;
  }
  
  .chatter-list .custom-select.new-query:focus,
  .chatter-list .custom-select.new-query:checked {
      box-shadow: none;
      border: 1px solid #E7E7EE;
  }
  
  .chatter-list .custom-select.new-query option {
      border-radius: 5px;
      background-color: #F6F6FA;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 400;
      padding: 0.466rem 0.8rem;
  }
  
  /* input */
  .chatter-list .label {
      padding-left: 0.4rem;
      margin-bottom: 0.53rem;
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  input.form-control,
  .chatter-list .input-group-sm > .form-control {
      padding: 0.533rem 0.8rem 0.533rem 1.066rem;
      height: 2.666rem !important;
      border-radius: 10px !important;
      border: 1px solid #E7E7EE;
      background-color: #F6F6FA;
      font-family: 'NanumGothic';
      color: #2E2E38;
      font-size: 16px;
      font-weight: 400;
      line-height: 150% !important;
  }
  
  input.form-control::placeholder {
      color: #AAA;
      font-family: 'NanumGothic';
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
  }
  
  /* form */
  .chatter-list .row {
      align-items: flex-end;
      margin-left: -0.7812vw;
      margin-right: -0.7812vw;
  }
  
  .chatter-list .row > .col,
  .chatter-list .row > [class*="col-"] {
      padding-right: 0.78125vw;
      padding-left: 0.7812vw;
  }
  
  /* keyword 영역 */
  .keyword-label-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  
  .keyword-label-area span {
      color: #747480;
      font-family: 'NanumGothic';
      font-size: 12px;
      font-weight: 500;
      line-height: 150%;
  }
  
  .keyword-label-area .search-toggle-area {
      display: flex;
      align-items: center;
      gap: 0 0.533rem;
      margin-bottom: 0.5rem;
  }
  
  .search-toggle-area .input-group-append {
      position: relative;
      width: 32px;
      height: 16px;
      margin-left: 0;
  }
  
  .search-toggle-area .input-group-append .input-group-text {
      padding: 0;
      background-color: transparent;
      border: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch {
      width: 100%;
      height: 100%;
      padding: 0;
      margin-right: 0 !important;
      min-height: unset;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label {
      width: 100%;
      height: 100%;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 32px;
      height: 16px;
      pointer-events: none;
      content: "";
      background-color: #E7E7EE;
      border: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label::after {
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      background-color: #747480;
      border-radius: 80px;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      background-color: #747480;
      transform: translateX(16px);
  }
  
  /* query 영역 */
  .chatter-list .query-title {
      height: auto !important;
      padding: 0 0 0 0.4rem !important;
      margin-bottom: 0.53rem;
      background-color: #FFF;
      border: none;
      border-radius: 0;
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .chatter-list .query-title::placeholder {
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .chatter-list .query-title:focus {
      border-color: unset;
      box-shadow: unset;
  }
  
  .chatter-list textarea {
      min-height: 50px;
      padding: 0.666rem 1.066rem;
      margin: 0;
      line-height: normal;
      border-radius: 10px;
      border: 1px solid #E7E7EE;
      background: #F6F6FA;
  }
  
  /* info 영역 */
  .info-table-wrap ul {
      padding-left: 0;
  }
  
  .info-table-wrap li {
      list-style: none;
  }
  
  .info-table-wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 2.666rem;
      width: 100%;
      margin-bottom: 2.666rem;
      font-family: 'NanumGothic';
  }
  
  .info-table-wrap .info-table {
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
      margin-bottom: 0;
      text-decoration: none;
      border-radius: 10px;
      overflow: hidden;
      background-color: #F6F6FA;
      color: #2E2E38;
      font-size: 14px;
  }
  
  .info-table-wrap .info-table .column {
      width: 50%;
  }
  
  .info-table-wrap .info-table .column .title {
      font-weight: 700;
      line-height: 60px;
      padding-left: 1.333rem;
  }
  
  .info-table-wrap .info-table .column .contents {
      padding: 0;
  }
  
  .info-table-wrap .info-table .column .content {
      line-height: 60px;
      border-bottom: 1px solid #E7E7EE;
      padding: 0 1.333rem;
  }
  
  .info-table-wrap .info-table .column .content:last-child {
      border-bottom: 0;
  }
  
  .info-table-wrap .info-table .column .content.blank {
      font-size: 0;
  }
  .query-button{
    justify-content: end; 
    display:flex;
  }
  .query-run-button{
    align-items: center; 
    justify-content: center !important; 
    display: flex; 
    min-height: 180px;
  }
  .query-list-button{
    width:130px;
    
  }
  .info-image{
    width: 100%;
    height: 100%;
    padding: 0 0 30px 0;
  }
  
  /* search detail */
  .toggle-line {
    position: relative;
    display: block;
    width: 100%;
    margin: 15px 0;
    text-align: center;
  }
  .toggle-line::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #DDDDE3;
    transform: translateY(-50%);
  }
  .toggle-line span {
    display: inline-flex;
    align-items: center;
    position: relative;
    padding: 8px 30px 8px 34px;
    background-color: #fff;
    color: #747480;
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    cursor: pointer;
  }
  .toggle-line span::after {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    margin-left: 12px;
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.166 6L8.49935 10.6667L3.83268 6' stroke='%23747480' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .toggle-line.open span::after {
    transform: rotate(180deg);
  }
  
  .chatter-list .row.search-detail-area ,
  .chatter-list .search-detail-area .row {
    align-items: center;
    margin-left: 0;
    margin-right: 0;
  }
  .chatter-list .search-detail-area .row:not(:only-child):last-child {
    margin-top: 0.5208vw;
  }
  .search-detail-area .form-control {
    min-height: unset;
    margin-bottom: 0;
    resize: none;
  }
  .search-detail-area .col-3 {
    width: 18.6197vw;
    margin-right: 1.171875vw;
    padding: 0 !important;
  }
  .search-detail-area .btn {
    height: 40px;
  }
  .search-detail-area .btn.btn-secondary {
    background-color: #dddde3;
    color: #2E2E38;
  }
  .search-detail-area .btn.btn-primary {
    width: 148px;
    height: 40px;
  }
  .search-detail-area .btn.col {
    flex-basis: calc(50% - 0.2604vw);
    flex-grow: 0;
    width: calc(50% - 0.2604vw);
    padding-right: 0;
    padding-left: 0;
  }
  .search-detail-area .btn.btn-primary:not(:disabled):not(.big):not(.disabled) {
    color: #fff;
  }
  .search-detail-area .btn.small {
    width: 100px;
  }
  .search-detail-area .btn.btn-primary.big {
    width: 148px;
    height: 186px;
  }
  .search-detail-area .query-button {
    flex-grow: 0;
  }
  .chatter-list .search-detail-area > .col,
  .chatter-list .search-detail-area > [class*="col-"] {
    padding: 0 0.2604vw;
  }
  .chatter-list .search-detail-area .custom-select.new-query {
    width: 100%;
    height: 186px;
    overflow: auto;
  }
  
  .chatter-list .select-box {
    width: 100%;
    height: 186px;
    padding: 20px 10px;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #fff;
  }
  .chatter-list .select-box .select-title {
    margin-bottom: 14px;
    padding-left: 10px;
    color: #000;
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  .chatter-list .search-detail-area .select-box .custom-select {
    padding: 0 !important;
    height: auto;
    min-height: unset;
    border-radius: 0;
    border: 0 none;
    background: none;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
  .chatter-list .select-box .custom-select option {
    margin-bottom: 4px;
    background-color: #fff;
  }
  .chatter-list .select-box .custom-select option:hover {
    background-color: #F6F6FA;
  }
  </style>